import { useContext } from 'react';

import { Setting } from '@apiContract';
import { useUpdateSettingsUserMutation } from '@api/settings';
import { SettingsContext } from '@contexts/SettingsContext';

export const useUpdateSettingsUser = () => {
  const settings = useContext(SettingsContext);
  const [updateSettings, { isLoading }] = useUpdateSettingsUserMutation();

  const updateSettingsUser = async (settingNames: Array<string>, values: Record<string, string | boolean>) => {
    const data = settings.reduce<Setting[]>((acc, setting) => {
      if (settingNames.includes(setting.name)) {
        acc.push({ ...setting, userSettingValue: values[setting.name].toString() });
      }
      return acc;
    }, []);

    return updateSettings(data).unwrap();
  };

  return { updateSettingsUser, isLoading };
};